var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"api-doc-container"},[_c('div',{staticClass:"doc-content"},[_c('h1',[_vm._v("HERON6000 文档中心")]),_c('nav',{staticClass:"doc-links"},[_c('router-link',{attrs:{"to":"/doc/instruction"}},[_vm._v("1、使用手册")]),_c('router-link',{attrs:{"to":"/doc/interface"}},[_vm._v("2、接口文档")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }